














































































import { Component, Mixins } from "vue-property-decorator";
import GlyphCustom from "../components/lib/GlyphCustom.vue";
import { onLoadJumpMixin } from "../mixins/onScrollAnimationMixin";
import { Location, Route } from "vue-router";
import { IPlatformInfo, IPlatformSocial, ITravelFilterData } from "../entities";
import { scrollByHash } from "../mixins/onScrollAnimationMixin";
import i18n from "@/i18n";

@Component({
  components: {
    GlyphCustom,
  },
})
export default class FooterSection extends Mixins(onLoadJumpMixin) {
  get navigation(): Object[] {
    const routes = [
      {
        title: this.$t("footer.home.title"),
        content: [
          {
            name: this.$t("footer.home.content[0]"),
            ref: { name: "Home", hash: "#travels" },
          },
          {
            name: this.$t("footer.home.content[1]"),
            ref: `https://apply.joinsherpa.com/travel-restrictions?language=${i18n.locale}`,
          },
          {
            name: this.$t("footer.home.content[2]"),
            ref: { name: "News" },
          },
        ],
      },
      {
        title: this.$t("footer.services.title"),
        content: [
          {
            name: this.$t("footer.services.content[0]"),
            ref: { name: "Services", hash: "#consultations" },
          },
          {
            name: this.$t("footer.services.content[1]"),
            ref: { name: "Services", hash: "#plans" },
          },
          {
            name: this.$t("footer.services.content[2]"),
            ref: { name: "Travels", hash: "" },
          },
        ],
      },
      {
        title: this.$t("footer.travels.title"),
        content: [
          {
            name: this.$t("footer.travels.content[0]"),
            ref: { name: "Travels", query: { category: "unique" } },
          },
          {
            name: this.$t("footer.travels.content[1]"),
            ref: { name: "Travels", query: { category: "magnifique" } },
          },
          {
            name: this.$t("footer.travels.content[2]"),
            ref: { name: "Travels", query: { category: "bonifique" } },
          },
        ],
      },
      {
        title: this.$t("footer.other.title"),
        content: [
          {
            name: this.$t("footer.other.content[0]"),
            ref: { name: "https://bonifique.store" },
          },
          {
            name: this.$t("footer.other.content[1]"),
            ref: { name: "About" },
          },
          {
            name: this.$t("footer.other.content[2]"),
            ref: { name: "Policy" },
          },
        ],
      },
    ];
    if (i18n.locale === "en") {
      routes[0].content.pop();
    }
    return routes;
  }

  get platform(): IPlatformInfo {
    return this.$storage.getters.getPlatformInfo();
  }

  get socials(): IPlatformSocial[] {
    return this.platform.social || [];
  }

  get currentYearsRange(): string {
    return FooterSection.getYearsRange(2020);
  }

  private static getYearsRange(start: number): string {
    let current = new Date().getFullYear();
    return start + (current > start ? "-" + current : "");
  }

  private static needToJumpByHash(here: Route, link: Location): boolean {
    return here.name === link?.name;
  }

  private moveToRoute(link: Location): void {
    if (link.name?.startsWith("http")) {
      window.open(link.name, "_blank");
      return;
    }
    let hash = link.hash;
    let samePage = FooterSection.needToJumpByHash(this.$route, link);
    if (samePage) {
      if (link.name === "Travels") {
        // set filters
        let filters: ITravelFilterData = {};
        let query = link.query;
        if (query) {
          Object.keys(query).forEach((field: string) => {
            let value: any = (query as any)[field];
            (filters as any)[field] = [value];
          });
        }
        this.$storage.actions.setFilters(filters);
      }
      if (hash) {
        scrollByHash(hash);
      } else {
        window.scrollTo({ top: 0 });
      }
    }
    this.$router.push(link);
  }
}
